import { iconForGroupedFilter } from 'components/organisms/tasks/criteria';
import {
  FilterableField,
  groupedFieldsTransformerFunction,
  GroupedOptions,
} from '../../organisms/tasks/fields';

interface FieldsProps {
  taskFields?: FilterableField[];
  projectFields?: FilterableField[];
  userFields?: FilterableField[];
}

interface GroupedFieldsProps {
  groupedFields: GroupedOptions<FilterableField>[];
}

const iconMapping = {
  taskFields: 'task',
  projectFields: 'project',
  userFields: 'user',
};

export const useFieldsAsGroupedFields = (
  props: FieldsProps,
): GroupedFieldsProps => ({
  groupedFields: Object.keys(props)
    .map((fieldType) => ({
      id: fieldType, // am assuming changing this ID here wont impact; coz i tried looking up and its not used anywhere
      options: props[fieldType],
      icon: iconForGroupedFilter[iconMapping[fieldType]],
    }))
    .map(groupedFieldsTransformerFunction),
});

export const useFieldsAsDefaultGroupedFields = (
  fields: FilterableField[],
): { defaultGroupedFields: GroupedOptions<FilterableField>[] } => ({
  defaultGroupedFields: [
    {
      id: 'default',
      label: 'Default',
      options: fields,
    },
  ].map(groupedFieldsTransformerFunction),
});
